import compact from "lodash/compact";

import { getLatestDateFromArray } from "common/util/getLatestDate";

import { IndicatorTableRow } from "../IndicatorTable";

export const getDataDatesFromRows = (rows: IndicatorTableRow[]) =>
  getLatestDateFromArray(compact(rows.map(({ latestDate }) => latestDate))) ?? null;
